import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Rocket, FileText, TrendingUp, Users, Layout, Monitor } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const iconMap = {
  1: Rocket,
  2: FileText,
  3: Users,
  4: TrendingUp,
  5: Layout,
  6: Monitor
};

const Services = () => {
  const { t } = useTranslation();

  const services = [
    { id: 1, titleKey: 'service1.title', descKey: 'service1.desc' },
    { id: 2, titleKey: 'service2.title', descKey: 'service2.desc' },
    { id: 3, titleKey: 'service3.title', descKey: 'service3.desc' },
    { id: 4, titleKey: 'service4.title', descKey: 'service4.desc' },
    { id: 5, titleKey: 'service5.title', descKey: 'service5.desc' },
    { id: 6, titleKey: 'service6.title', descKey: 'service6.desc' },
  ];

  return (
    <section id="services" data-testid="services-section" className="py-24 bg-[#0a1628] relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%2300D4FF' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
      }}></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 data-testid="services-title" className="text-4xl md:text-5xl font-bold text-[#00D4FF] mb-4">
            {t('services.title')}
          </h2>
          <div className="w-32 h-1 bg-[#00E5A0] mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((service) => {
            const Icon = iconMap[service.id];
            return (
              <Card
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className="bg-[#1a2942]/50 backdrop-blur-sm border-[#00D4FF]/30 hover:border-[#00E5A0] transition-all duration-300 group hover:transform hover:scale-105 hover:shadow-2xl hover:shadow-[#00E5A0]/20"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-[#00D4FF]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#00E5A0]/20 transition-colors duration-300">
                    <Icon className="w-7 h-7 text-[#00D4FF] group-hover:text-[#00E5A0]" />
                  </div>
                  <CardTitle className="text-white text-xl group-hover:text-[#00E5A0] transition-colors duration-300">
                    {t(service.titleKey)}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-300 leading-relaxed">
                    {t(service.descKey)}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;